/**
 * Getter functions for step and substep IDs
 */

/**
 * Gets the step ID from a step object
 * @param {Object} step - Step object
 * @returns {number|string} Step ID
 */
export const getStepId = (step) => step?.step_id ?? step?.id;

/**
 * Gets the substep ID from a substep object
 * @param {Object} substep - Substep object
 * @returns {number|string} Substep ID
 */
export const getSubstepId = (substep) => substep?.substep_id ?? substep?.id;
